import { styled } from 'styled-components';

export const ProfileImg = styled.img`
    width: 164px;
    height: 164px;
    border-radius: 50%;
    margin: 29px;
    object-fit: cover
`